module.exports = __webpack_public_path__ + "img/safe2.320b8f41.png";